(function ($) {

    $(function () {

        // get the disabled dates once for all datepickers.
        var disabledDates = getDisabledDates();

        $('input.date').each(function () {
            // we dont use input[type="date"] because, well you know.. MS Edge....
            initDatepicker($(this), disabledDates);
        });

        /**
         * We use focus just in case some datepicker fails to initiate on page load
         */
        $('input.date').focus(function () {
            // we dont use input[type="date"] because, well you know.. MS Edge....
            initDatepicker($(this), disabledDates);
        });

        /**
         * Init every date field with datepicker on load
         */
        $('input[type="date"]').each(function () {
            initDatepicker($(this), disabledDates);
        });

        /**
         * init date picker by element
         * @param el
         * @param disabledDates
         */
        function initDatepicker(el, disabledDates) {

            el.datepicker({
                uiLibrary: 'bootstrap4',
                format: 'yyyy-mm-dd',
                // locale: 'nl',
                // weekStartDay: 1,
                minDate: el.hasClass('min-date-now') ? new Date() : '',
                disableDaysOfWeek: el.hasClass('disableWeekend') ? [0, 6] : [],
                disableDates: function (date) {
                    if (!el.hasClass('disableHolidays')) {
                        return true;
                    }

                    format = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

                    if (disabledDates.indexOf(format) == -1) {
                        return true;
                    }
                    return false;
                }
            });

        }
    });

    /**
     *
     * @returns {[]}
     */
    function getDisabledDates() {

        var holidays = [];

        $.getJSON('/api/v1/holidays', function (json) {

            $.each(json.data, function (i, obj) {
                holidays.push(obj.date)
            });
        });

        return holidays;
    }

    // Show uploaded filename on file inputs
    $(document).on('change', 'input[type="file"]', function (e) {
        e.preventDefault();
        let fileName = e.target.files[0].name;
        $(this).next('.custom-file-label').html(fileName);
    });

}(jQuery));

$(window).on('load', function () {
    toggleClasses();
    selectMob();
    checkWorck();
});

$(window).on('resize', function () {
    toggleClasses();
    selectMob();
    checkWorck();
});

$(document).ready(function () {

    // slider directions init
    $('#directionCarousel').carousel({
        interval: false
    });
    // slider reviews init
    $('#carouselReview').carousel({
        interval: false
    });
    $('#blogCarousel').carousel({
        interval: false
    });

    $('#carouselReview-side').carousel({
        interval: 5000
    });

    // fixed sidebar faq page
    if ($('.js-sidebar').length > 0) {
        var fixedAside = $('.js-sidebar');
        var sidebarHeight = fixedAside.outerHeight(true);
        var sidebarTop = fixedAside.offset().top;
        var sidebarBottom = sidebarTop + sidebarHeight;
        var topLimit = sidebarTop;
        
        $(window).scroll(function () {
            scrollSidebar();
        });
        function scrollSidebar() {
            let bottomLimit = topLimit + fixedAside.parents('.aside').first().outerHeight(true) - 80;
            let scrollTop = $(window).scrollTop();
            sidebarTop = fixedAside.offset().top;
            sidebarBottom = sidebarTop + fixedAside.outerHeight(true);

            let limit = bottomLimit - sidebarHeight;
            if (scrollTop <= limit) {
                if(scrollTop >= topLimit) {
                    fixedAside.stop().animate({
                        top: scrollTop - topLimit
                    });
                } else {
                    fixedAside.stop().animate({
                        top: 0
                    });
                }
            } else if (scrollTop > limit) {
                fixedAside.stop().animate({
                    top: bottomLimit - sidebarHeight - topLimit
                });
            } else {
                fixedAside.stop().animate({
                    top: 0
                });
            }
        }
        scrollSidebar();

        // scrolling to id faq page
        $('.js-sidebar a[href^="#"]').on('click', function (event) {
            event.preventDefault();
            $('html').animate({
                scrollTop: $($(this).attr('href')).offset().top - 20
            }, 600);
        });
    }

    // sroll up btn
    if ($('.js-btn__scroll').length > 0) {
        $('.js-btn__scroll').on('click', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'slow');
        });
    }
});

// how work check parent width
function checkWorck() {
    if ($('.js-how-work').length > 0) {
        if ($('.js-how-work').parent().width() < 800) {
            $('.js-how-work').parent().css({
                'padding': '15px',
                'margin-bottom': '20px'
            })
            $('.js-how-work').removeClass('how-work__horizontal');
            $('.js-how-work').addClass('how-work__vertical');
        } else {
            $('.js-how-work').addClass('how-work__horizontal');
            $('.js-how-work').removeClass('how-work__vertical');
        }
    }
}
// resize window toggle classes
function toggleClasses() {
    if ($(window).width() < 992) {
        $('.js-article_left').removeClass('tab-content');
        $('.js-article_left').removeClass('accordion');
        $('.js-documents__article').removeClass('fade');
        $('.js-accordion__content').addClass('collapse');
        $('.js-documents__article').removeAttr('role');
    } else {
        $('.js-article_left').addClass('tab-content');
        $('.js-documents__article').addClass('fade');
        $('.js-article_left').addClass('accordion');
        $('.js-documents__article').attr('role', 'tabpanel');
        $('.js-accordion__content').removeClass('collapse');
    }
}
// services page select for content show
function selectMob() {
    if ($(window).width() < 992) {
        var items = $('.js-services__content');
        $(document).on('change', '.js-select', function () {
            var itemIndex = parseInt(this.value);
            var item = items[itemIndex];
            if (item !== undefined) {
                items.each(function () {
                    if (item !== this) {
                        $(this).removeClass('active show');
                    }
                });
                $(item).addClass('active show');
            }
        });
    }
}

window.setTrustpilotRating = function (rating) {
    let whole = Math.floor(rating);
    let decimal = Math.floor((rating - whole) * 10) / 10;
    let halfStarProgress = (decimal < 0) ? 0 : (decimal > 1) ? 1 : decimal;

    $('.trustpilot-stars').each(function () {
        for (let i = 0; i < 5; i++) {
            let $star = $($(this).find('.trustpilot-star')[i]);
            if (i < whole) {
                $star.find('#star-stop1').first()[0].setAttribute("offset", 1);
                $star.find('#star-stop2').first()[0].setAttribute("offset", 1);
            } else {
                $star.find('#star-stop1').first()[0].setAttribute("offset", halfStarProgress);
                $star.find('#star-stop2').first()[0].setAttribute("offset", halfStarProgress);
            }
        }
    });
}
